import { useToasts } from '../lib/toast';
import styles from './Toasts.module.css';

export function Toasts() {
  const { items, dismiss } = useToasts();
  if (items.length === 0) return null;
  return (
    <div className={styles.stack} role="status" aria-live="polite">
      {items.map((t) => (
        <button
          key={t.id}
          className={`${styles.toast} ${styles[t.kind]}`}
          onClick={() => dismiss(t.id)}
        >
          {t.text}
        </button>
      ))}
    </div>
  );
}
